import React from "react";
import styled, { css } from "styled-components";

interface ButtonBaseProps {
  children?: any;
  onClick?: (e?: any) => void;
  onClickCheck?: (e?: Event & { target: Element }) => void;
  name?: string;
  sx?: any;
  ref?: React.Ref<HTMLButtonElement>;
  className?: string;
  disable?: boolean;
  value?: number;
}

const ButtonBase: React.FC<ButtonBaseProps> = ({
  children,
  onClick,
  ref,
  onClickCheck,
  className,
  disable,
  value,
  ...rest
}) => {
  return (
    <ButtonBaseRoot
      ref={ref}
      onClick={(e?: any) => {
        onClick?.(e);
        onClickCheck?.(e);
      }}
      className={className}
      {...rest}
      value={value}
    >
      {children}
    </ButtonBaseRoot>
  );
};

export default ButtonBase;

const ButtonBaseRoot = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: transparent;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent !important;
    border: 0;
    outline: 0;
    margin: 0;
    border-radius: 0;
    padding: 0;
    cursor: pointer;
    user-select: none;
    vertical-align: middle;
    moz-appearance: none; /*Reset*/
    -webkit-appearance: none; // Reset
    text-decoration: none,
    color: inherit;
    '&::-moz-focus-inner': {
    border-style: none; // Remove Firefox dotted outline.
    font-family: "Pretendard", sans-serif;
    };

 
    ${(props: any) => props.sx};
       ${(props: any) =>
         props.disable
           ? css`
               color: #bec3cb;
             `
           : null}
`;
